module.exports = __webpack_public_path__ + "static/media/miami-18.3cd56c59.jpg";